<template>
  <AbsPopup id="ProofPopup" title="인증하기" type="confirm" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div class="body">
        <div class="myproofBody">
          <div class="Bar title">
            <span>STEP.01 본인인증</span>
            <span>휴대폰 인증</span>
          </div>
          <div v-if="!myproof">
            <div class="descriptionBody">
              <span>고객님의 개인정보 보호 및 본인확인을 위하여 본인 인증이 필요 합니다.<br />아래의 '인증하기'버튼을 클릭해 본인 인증을 진행해 주세요</span>
            </div>
            <div class="box">
              <ul>
                <li>
                  <span>신상 도용은 범죄 행위 입니다.</span>
                </li>
                <li>
                  <span>타인의 신상 도용 시 주민등록법에 따라 3년 이하의 징역이나 1천만원 이하의 벌금에 처해지며, 사전통보 없이 회원가입이 취소될 수 있습니다.</span>
                </li>
              </ul>
            </div>
            <div class="button">
              <Ubutton size="small" text="인증 하기" state="active" @click.native="myproofclick"/>
            </div>
          </div>
          <div v-else class="success">
            <div class="title">
              <b>본인 인증</b>
            </div>
            <div class="right">
              <div class="agree">
                <input type="checkbox" id="myproof" v-model="myproof" :disabled="true"/>
                <label for="myproof">
                  <span>본인인증 완료</span>
                </label>
              </div>
              <div class="agree">
                <input type="checkbox" :id="adult ? 'adult' : 'notadult'" v-model="adult" :disabled="true"/>
                <label v-if="adult" for="adult">
                  <span>성인 인증 완료</span>
                </label>
                <label v-else for="notadult">
                  <span>성인이 아닙니다</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="myproof && !adult && !guardian">
            <div class="title">
              <b><span>보호자 인증</span></b>
            </div>
            <div class="descriptionBody">
              <span>성인이 아닌 경우 안전한 출판 서비스를 위해 보호자 동의 서비스를 시행하고<br />있습니다. 보호자 동의 인증 확인후 출판 서비스를 신청하실 수 있습니다.</span>
            </div>
            <div class="button">
              <Ubutton size="small" text="인증 하기" state="active" @click.native="guardianclick"/>
            </div>
          </div>
          <div v-else-if="myproof && !adult && guardian" class="success">
            <div class="title">
              <b><span>보호자 인증</span></b>
            </div>
            <div class="right">
              <div class="agree">
                <input type="checkbox" id="myproof" v-model="myproof" :disabled="true"/>
                <label for="myproof">
                  <span>본인인증 완료</span>
                </label>
              </div>
              <div class="agree">
                <input type="checkbox" :id="guardianAdult ? 'adult' : 'notadult'" v-model="guardianAdult" :disabled="true"/>
                <label v-if="guardianAdult" for="adult">
                  <span>성인 인증 완료</span>
                </label>
                <label v-else for="notadult">
                  <span>성인이 아닙니다</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isguardian === false" class="adultBody" :class="{guide: !adult || !guardianAdult}">
          <div class="Bar" :class="{title: adult || guardianAdult}">
            <span>STEP.02 메일인증</span>
            <span>본인 인증 필요</span>
          </div>
          <div v-if="!adult && !guardianAdult" class="center">
            <span>본인인증이 필요 합니다.</span>
          </div>
          <div v-else>
            <div v-if="!sendEmail">
              <div class="descriptionCenter">
                <span><u>{{ email }}</u> (으)로 인증코드가 발송 됩니다.<br /></span>
                <span>메일인증을 진행 하시겠습니까?</span>
              </div>
              <div v-if="myproof" class="button">
                <Ubutton size="small" text="인증 하기" state="active" @click.native="emailClick"/>
              </div>
            </div>
            <div v-else class="mailcomfirm">
              <div class="descriptionCenter">
                <span><u>{{ email }}</u> (으)로 인증코드를 전송하였습니다.<br /></span>
                <span>해당 이메일을 확인해주시기 바랍니다.</span>
              </div>
              <ul>
                <li>
                  <span class="title"><b>인증코드</b></span><span class="require">*</span>
                </li>
                <li>
                  <UInput type="text" line="bottom" placeholder="이메일로 받으신 인증코드를 입력해 주세요" v-model="cert" @enter="checkCert"/>
                  <span>{{ timeString }}</span>
                  <Ubutton text="확인" size="xxsmall" iconSize="xsmall" :state="certState" @click.native="checkCert"/>
                </li>
                <li class="error">
                  <span :class="certErrorState">{{ certError }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import {getTime, toTime} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.$emit('loading', false)
    if (this.sendEmail) {
      this.time = {value: 60 * 5, date: new Date()}
      this.timeInterval = setInterval(this.changeTime, 1000)
      this.changeTime()
    }
    // this.myproof = true
    // this.adult = false
    // this.guardian = true
    // this.name = '박기태'
    // this.birthDate =
    // this.proof = {proof: true, adult: false, name: '박기태', birthDate: '1981년 05월 12일', guardian: true, guardianAdult: true, guardianname: '이학준', guardianbirthDate: '1979년 07월 01일', imp_uid: '1111'}
    if (this.option.param.proof) {
      this.myproof = true
      this.adult = false
      this.name = this.option.param.proof.name
    }
  },
  beforeDestroy () {
  },
  data () {
    return {
      name: '',
      birth: null,
      birthDate: '',
      myproof: false,
      adult: false,
      guardian: false,
      guardianAdult: false,
      guardianname: '',
      guardianBirth: null,
      guardianbirthDate: '',
      imp_uid: '',
      impdate: null,
      guardian_imp_uid: '',
      guardian_impdate: null,
      adultOpen: this.option.param.adultopen,
      adultStep: this.option.param.adultopen,
      phone: (this.option.param.phone) ? this.option.param.phone : '',
      email: (this.option.param.email) ? this.option.param.email : '',
      isguardian: (this.option.param.guardian) ? this.option.param.guardian : false,
      sendEmail: false,
      cert: '',
      certError: '',
      certErrorState: '',
      certState: 'guide',
      certDate: null,
      time: null,
      timeInterval: null,
      timeString: ''
    }
  },
  name: 'ProofPopup',
  watch: {
    cert (val) {
      if (val.length !== 0 && (val.length < 9 || val.length > 13)) {
        this.certError = '인증코드를 정확히 입력해 주세요'
        this.certErrorState = 'require'
        this.certState = 'disable'
      } else {
        this.certError = ''
        this.certErrorState = 'require'
        this.certState = 'deactive'
      }
    }
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '확인', state: this.certState, click: this.submit}
      ]
    }
  },
  methods: {
    myproofclick () {
      this.impdate = getTime()
      window.IMP.certification({
        company: 'https://upenbe.com',
        merchant_uid: this.$store.getters.id + this.impdate,
        phone: this.phone
      }, (rsp) => {
        console.log('myproofclick obj', rsp)
        if (rsp.success) {
          this.$http.post('/api/user/certificationInfo', {imp: rsp.imp_uid}).then((e) => {
            console.log(e)
            if (e.success) {
              if (e.unique_key) {
                this.name = e.name
                this.birth = e.birth
                this.birthDate = e.birthDate
                this.imp_uid = rsp.imp_uid
                this.myproof = true
                this.adult = e.adult
              } else {
                // 계정 본인과 일치 하지 않음
              }
            }
          })
        }
      })
    },
    guardianclick () {
      this.guardian_impdate = getTime()
      window.IMP.certification({
        company: 'https://upenbe.com',
        merchant_uid: this.$store.getters.id + this.guardian_impdate,
        phone: this.phone
      }, (rsp) => {
        console.log('myproofclick obj', rsp)
        if (rsp.success) {
          this.$http.post('/api/user/certificationInfo', {imp: rsp.imp_uid}).then((e) => {
            console.log(e)
            if (e.success) {
              this.guardianname = e.name
              this.guardianBirth = e.birth
              this.guardianbirthDate = e.birthDate
              this.guardian_imp_uid = rsp.imp_uid
              this.guardianAdult = e.adult
              this.guardian = true
              if (this.isguardian) {
                this.certState = 'deactive'
              }
            }
          })
        }
      })
    },
    emailClick () {
      this.$emit('loading', true)
      this.$http.post('/api/auth/searchEmail', {email: this.email}).then(e => {
        console.log(e)
        this.$emit('loading', false)
        if (e.success) {
          this.sendEmail = true
          // this.time = {value: 60 * 5, date: new Date()}
          // this.timeInterval = setInterval(this.changeTime, 1000)
          // this.changeTime()
        } else {
          if (e.state === 2) {

          }
        }
      })
    },
    changeTime () {
      var c = new Date()
      var dt = Math.ceil((this.time.value * 1000) - (c - this.time.date))
      var dm = Math.floor(dt / 1000 / 60 % 60)
      var ds = Math.floor(dt / 1000 % 60)
      this.timeString = toTime(dm) + ':' + toTime(ds)
      if (dt < 0) {
        clearInterval(this.timeInterval)
        this.sendEmail = false
      }
    },
    checkCert () {
      if (this.certState === 'deactive') {
        this.$http.post('/api/auth/confirmUser', {email: this.email, token: this.cert, type: 'proof', state: '0'}).then((e) => {
          console.log(e)
          if (e.success) {
            this.certDate = new Date()
            this.certError = '인증이 확인 되었습니다.'
            this.certErrorState = 'active'
            this.certState = 'active'
            this.certButtonState = 'in-active'
          } else {
            // 통신에러?
            if (e.state === 1) {
              this.certError = '인증코드가 잘못 입력되었습니다. 다시 확인후 입력해 주세요.'
              this.certErrorState = 'require'
              this.certState = 'deactive'
            } else {
              this.certError = ''
              this.certErrorState = 'require'
              this.certState = 'deactive'
            }
          }
        })
      }
    },
    submit () {
      console.log('submit')
      if (this.certState === 'active') {
        this.$emit('submit', {
          proof: this.myproof,
          adult: this.adult,
          name: this.name,
          birth: this.brith,
          birthDate: this.birthDate,
          imp_uid: this.imp_uid,
          guardian: this.guardian,
          guardianAdult: this.guardianAdult,
          guardianname: this.guardianname,
          guardianBirth: this.guardianBirth,
          guardianbirthDate: this.guardianbirthDate,
          guardian_imp_uid: this.guardian_imp_uid,
          certDate: this.certDate.getTime(),
          impdate: this.impdate,
          guardian_impdate: this.guardian_impdate
        })
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#ProofPopup {
  padding: 10px 0;
  width: 520px;
  color: var(--text-base);
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 5px 0px;
  padding: 15px;
  line-height: 26px;
  text-align: left;
}
.body > div {
  display: flex;
  flex-direction: column;
}
.body > div:nth-last-child(1n+2) {
  margin-bottom: 20px;
}
.body .success {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 3px 0px;
}
.body .success .right {
  display: flex;
  flex-direction: row;
}
.body .success .right .agree + .agree {
  margin-left: 15px;
}
.body .mailcomfirm {
  display: flex;
  flex-direction: column;
}
.mailcomfirm ul {
  list-style: none;
}
.mailcomfirm ul li {
  display: flex;
  flex-direction: row;
}
.mailcomfirm .input {
  flex: 1;
}
.mailcomfirm ul li span {
  margin: 0 10px 0px 10px;
}
.body .Bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0px 5px;
  margin-bottom: 10px;
  align-items: center;
  border-bottom: 1px solid var(--line-guide);
}
.body .Bar.title {
  border-bottom: 1px solid var(--line-base);
}
.body .Bar span:first-child {
  font-weight: bold;
}
.body .Bar span:last-child {
  margin-left: auto;
}
.body .descriptionBody {
  padding-left: 5px;
}
.body .descriptionCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-base);
}
.body .box {
  border: 1px dashed var(--line-guide);
  padding: 5px 5px;
  font-size: 0.95em;
  /* letter-spacing: -0.02em; */
}
.body ul {
  padding-left: 20px;
}
.body .myproof {
  flex-direction: column;
}
.body .phoneInput {
  display: flex;
  justify-content: center;
  margin: 10px 0px;
}
.body .error {
  display: flex;
  justify-content: center;
}
.body .button {
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
}
.body .agree {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.body .agree input[type=checkbox] {
  display: none;
}
.body .agree input[type=checkbox] + label {
  position: relative;
  display: inline-block;
  padding-left: 23px;
  cursor: pointer;
}
.body .agree input[type=checkbox] + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.body .agree input[type=checkbox]:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.body .agree input[type=checkbox]:checked + label {
  color: var(--active);
}
.body .agree input[type=checkbox]#notadult + label::before {
  content: 'x';
  position: absolute;
  color: var(--require);
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--require);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.body .agree input[type=checkbox]#notadult + label {
  color: var(--require);
}
.adultOpen .agree {
  margin-top: 10px;
}
.adultBody .center, .adultOpen .center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ProofPopup.vue